import { React, useRef, useState } from '../../shared/react.js';
import { Icon } from '../../shared/icons.js';
import { SearchComposer } from '../search/SearchComposer.js';
import { RecentQueries } from '../history/RecentQueries.js';
import { QueryCanvas } from '../query/QueryCanvas.js';
import { SavedCollections } from '../collections/SavedCollections.js';
import { useAppRuntime, useAppState } from '../../app/app.context.js';

function NeedleMark() {
  return (
    <svg className="needle-mark" viewBox="0 0 34 46" aria-hidden="true">
      <path d="M22 2 11 23l6-1-5 22 12-25-6 2Z" fill="none" stroke="currentColor" strokeWidth="1.35"/>
    </svg>
  );
}

export function SearchSidebar() {
  const runtime = useAppRuntime();
  const state = useAppState();
  const collectionsRef = useRef(null as HTMLElement | null);
  const [workspaceOpen, setWorkspaceOpen] = useState(false);

  return (
    <aside className={`search-sidebar${workspaceOpen ? ' is-workspace-open' : ''}`}>
      <div className="brand-lockup">
        <NeedleMark/>
        <span className="brand-lockup__copy"><strong>Needle</strong></span>
        <button type="button" className="workspace-mobile-toggle" onClick={() => setWorkspaceOpen((open: boolean) => !open)} aria-expanded={workspaceOpen} aria-label={workspaceOpen ? 'Close search workspace' : 'Open search workspace'}>
          <Icon name="layers" size={16}/><span>{state.queryTerms.length + state.queryFilters.length}</span>
        </button>
      </div>

      {workspaceOpen && (
        <button
          type="button"
          className="workspace-scrim"
          onClick={() => setWorkspaceOpen(false)}
          aria-label="Close search workspace"
        />
      )}

      <div className="sidebar-search" aria-labelledby="search-title">
        <div className="sidebar-section-heading"><h1 id="search-title">Search</h1></div>
        <SearchComposer/>
        {state.errorMessage && <p className="sidebar-error" role="alert">{state.errorMessage}</p>}
      </div>

      <div className="sidebar-scroll">
        <div className="workspace-mobile-header">
          <strong>Search workspace</strong>
          <button type="button" className="icon-button" onClick={() => setWorkspaceOpen(false)} aria-label="Close search workspace"><Icon name="close" size={16}/></button>
        </div>
        <QueryCanvas/>
        <RecentQueries/>
        <SavedCollections sectionRef={collectionsRef}/>
        <div className="sidebar-primary-actions">
          <button type="button" onClick={() => void runtime.branchCurrentSearch()} disabled={state.queryTerms.length === 0}>
            <Icon name="branch" size={15}/><span>Branch search</span>
          </button>
          <button type="button" onClick={() => void runtime.saveCurrentCollection()} disabled={!state.approximate}>
            <Icon name="bookmark" size={15}/><span>Save collection</span>
          </button>
        </div>
      </div>

      <nav className="sidebar-footer" aria-label="Secondary navigation">
        <a href="https://www.metmuseum.org/hubs/open-access" target="_blank" rel="noreferrer" aria-label="The Met Open Access"><Icon name="book"/></a>
        <button type="button" aria-label="Saved collections" onClick={() => {
          setWorkspaceOpen(true);
          requestAnimationFrame(() => {
            collectionsRef.current?.scrollIntoView({ block: 'nearest' });
            (collectionsRef.current?.querySelector('button') as HTMLButtonElement | null)?.focus({ preventScroll: true });
          });
        }}><Icon name="bookmark"/></button>
      </nav>
    </aside>
  );
}
